<template>
  <v-container style="min-height: calc(100vh - 124px);">
    <v-row class="mt-0">
      <v-col cols="12" md="12">
        <v-text-field
          dense
          prepend-inner-icon="search"
          v-model="paramdata.keyword"
          label="Search"
          name="keyword"
          @input="getDataFilter">
        </v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="datalist.length > 0" class="mt-0">
      <v-col cols="12" class="pt-0">
        <div
          class="link-list-style class-cursor"
          v-for="(kamus, i) in datalist"
          :key="i"
          @click="detailTrivia(kamus)">
          <div
            class="item-list-style py-3">
            <span>{{ kamus.question }}</span>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <infinite-loading :identifier="infiniteId" @infinite="getData">
          <div slot="spinner">Loading...</div>
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </v-col>
    </v-row>
    <!-- dialog -->
    <v-dialog
      v-model="dmodal.trivia"
      max-width="700px"
      v-if="dmodaldata.trivia">
      <v-card>
        <v-card-title class="title">
          Trivia
          <v-spacer></v-spacer>
          <v-icon class="float-right" color="red" @click="dmodal.trivia = false">mdi-close-box</v-icon>
        </v-card-title>
        <v-card-text>
          <div class="mb-3">
            <span class="font-weight-black">Question:</span><br>
            {{ dmodaldata.trivia.question }}
          </div>
          <div v-if="showans">
            <div class="mb-3">
              <span class="font-weight-black">Answer:</span><br>
              <span>{{ dmodaldata.trivia.answer }}</span>
            </div>
            <div class="mb-3">
              <span class="font-weight-black">Information:</span><br>
              {{ dmodaldata.trivia.information }}
            </div>
          </div>
          <v-btn
            class="text-capitalize"
            color="success"
            x-small
            tile
            @click="showans = true">
            Answer
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Alertsp from '../components/Alert.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { mapState } from 'vuex';

export default {
  name: 'Trivia',
  data: () => ({
    selectedItem: 1,
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      check: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    datalist: [],
    listcategory: ['job-fair', 'motivation'],
    panduan: null,
    paramdata: {
      keyword: '',
      limit: 15,
      offset: 0,
    },
    check: {
      reference: '',
    },
    formcheck: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
    infiniteId: +new Date(),
    dmodal: {
      trivia: false,
    },
    dmodaldata: {
      trivia: null,
    },
    showans: false,
  }),
  mounted() {
    // this.getData();
    if (this.$route.query.reference && this.$route.query.reference !== '') {
      this.check.reference = this.$route.query.reference;
    }
    this.$store.commit('UPDATE_TITLE', 'Trivia QnA');
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
    ]),
  },
  methods: {
    detailTrivia(dtrivia) {
      this.showans = false;
      this.dmodal.trivia = true;
      this.dmodaldata.trivia = JSON.parse(JSON.stringify(dtrivia));
      // console.log(this.dmodaldata.trivia);
    },
    getDataFilter() {
      this.paramdata.offset = 0;
      this.datalist = [];
      this.infiniteId += 1;
    },
    getData($state) {
      this.axios
        .get(
          this.api + '/public/trivia',
          {
            params: this.paramdata,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              if (resdata.data.length > 0) {
                this.paramdata.offset += this.paramdata.limit;
                this.datalist.push(...resdata.data);
                if (this.datalist.length < this.paramdata.offset) {
                  if ($state !== false) {
                    $state.complete();
                  }
                } else {
                  if ($state !== false) {
                    $state.loaded();
                  }
                }
              } else {
                if ($state !== false) {
                  $state.complete();
                }
              }
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
  },
  components: {
    Alertsp,
    InfiniteLoading,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  $main-color: #216185;

  .item-list-style{
    border-bottom: solid thin #BDBDBD;
  }
  .item-list-style:hover{
    color: $main-color;
    border-color: $main-color;
  }
  a.link-list-style{
    text-decoration: none;
    color: black;
  }
</style>
